

















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DxButton} from "devextreme-vue/ui/button";
import DSelectbox from "@/components/DSelectbox/selectbox.vue";
import { DxScrollView } from 'devextreme-vue';
import TableGrid from '@/components/TableGrid/grid.vue';
import CutPopup from "@/components/Cut/cut-popup.vue"
import CutHistoryPopup from "@/components/Cut/cut-history-popup.vue"
import { months, type_cut } from "@/constants";
import CutService from "@/services/cut-service";
import {YearType, CutType, CutWithAccept, Contractor} from "@/services/models-service";
import YearService from "@/services/years-service";
import { confirm } from "devextreme/ui/dialog";
import YearPopup from "@/views/settings/components/year-popup.vue";
import AcceptService from "@/services/accept-service";
import { AcceptData, AcceptDataBackend } from "@/services/models-service";
import * as _ from "lodash";
import notify_service from "@/services/notify_service";
import getGridInstance from "@/utils/grid-instance";
import WebSocketService from "@/services/websocket_service";
import DictsCacheService from "@/services/dicts_cache_service";
import ContractorService from "@/services/contractor-service";
import TariffService from "@/services/tariff-service";
import AuthService from "@/services/auth_service";
import UserAccessService from "@/services/user_access_service";


@Component({
  name: "Cut",
  components: {
    DxButton,
    DSelectbox,
    TableGrid,
    CutPopup,
    CutHistoryPopup,
    YearPopup,
    DxScrollView
  }
})
export default class extends Vue {
private current_year: string = '';
private cut_service = CutService;
public columns: Array<any> = [];
public all_years: YearType [] = [];
private target_cut: CutWithAccept | null = null;
public cuts: CutWithAccept[] = [];
public yearPopup = {
    visible: false
}

  public isLoaded: boolean = true;

public cutPopup = {
    visible: false,
    editMode: false
}
public cutHistoryPopup = {
    visible: false,
}

public onRefreshTable() {
  this.getCutsYear()
}

public get length() {
    return this.cuts.length;
  }

private initColumns() {
        this.columns = [
        {
            dataField: "number",
            dataType: "string",
            caption: "№ п/п",
            allowEditing: true,
            validationRules: [
              {type: 'pattern', pattern: /^[0-9]*$/i, ignoreEmptyValue: true, message: 'Номер должен быть цифрой'},
              {type: 'range', min: 1, ignoreEmptyValue: true, message: 'Номер должен быть большее нуля'},
              {
                type: 'custom',
                message: 'Номер не должен быть большее количества срезок',
                validationCallback: this.checkLenght
              }
            ],
        },{
            dataField: "name",
            dataType: "string",
            caption: "Название срезки",
            allowEditing: false
        },{
            dataField: "type",
            dataType: "string",
            caption: "Тип срезки",
            allowEditing: false
        },{
            dataField: `copy_year_name`,
            dataType: "string",
            caption: "Основа срезки",
            allowEditing: false
        },{
            dataField: `note`,
            dataType: "string",
            caption: "Примечание",
            allowEditing: false
        },{
            dataField: "visible_for",
            dataType: "string",
            caption: "Видимость",
            allowEditing: false,
            lookup: {
              dataSource: [
                { value: 'Видимый для администратора', label: 'Видимый для администратора' },
                { value: 'Видимый для всех', label: 'Видимый для всех' },
                { value: 'Скрыт для всех', label: 'Скрыт для всех' },
              ],
              valueExpr: 'value',
              displayExpr: 'label',
            },
        },{
            dataField: "january",
            dataType: "boolean",
            caption: "Янв",
            allowEditing: false
        },{
            dataField: "february",
            dataType: "boolean",
            caption: "Фев",
            allowEditing: false
        },{
            dataField: "march",
            dataType: "boolean",
            caption: "Мар",
            allowEditing: false
        },{
            dataField: "april",
            dataType: "boolean",
            caption: "Апр",
            allowEditing: false
        },{
            dataField: "may",
            dataType: "boolean",
            caption: "Май",
            allowEditing: false
        },{
            dataField: "june",
            dataType: "boolean",
            caption: "Июн",
            allowEditing: false
        },{
            dataField: "july",
            dataType: "boolean",
            caption: "Июл",
            allowEditing: false
        },{
            dataField: "august",
            dataType: "boolean",
            caption: "Авг",
            allowEditing: false
        },{
            dataField: "september",
            dataType: "boolean",
            caption: "Сен",
            allowEditing: false
        },{
            dataField: "october",
            dataType: "boolean",
            caption: "Окт",
            allowEditing: false
        },{
            dataField: "november",
            dataType: "boolean",
            caption: "Ноя",
            allowEditing: false
        },{
            dataField: "december",
            dataType: "boolean",
            caption: "Дек",
            allowEditing: false
        },
        ]
    }

  async created() {
    this.isLoaded = false;

    this.all_years = YearService.YearList;
    if (YearService.current && YearService.current.id) {
      this.current_year = YearService.current.id
    } else if (this.all_years.length) {
      this.current_year = this.all_years[this.all_years.length - 1].id
    }
    await this.getCutsYear();

    this.isLoaded = true;

    if (this.$options.sockets) {
      this.$options.sockets.onmessage = async (data: any) => {
        let res = WebSocketService.handleMsg(data, 'cuts_update');

        if (!_.isNil(res)) {
          if (res.year_id === this.current_year) {

            if (res.success === true) {
              //
            } else {
              notify_service.error('Ошибка удаления срезки')
            }

            this.target_cut = new CutWithAccept();
            await this.getCutsYear();

            const grid = getGridInstance(this.$refs.typeGrid);
            grid.endCustomLoading()
          }
        }
      }
    }
  }
  private destroyed(): void {
    if (this.$options.sockets) {
      delete this.$options.sockets.onmessage;
    }
  }

  async mounted() {
    this.initColumns();
  }

  async getCutsYear() {
    try {
      const response = await this.cut_service.getWithAccepts(this.current_year);
      console.log(response)
      if (response) {
        this.cuts = response;
        this.cuts = this.cuts.sort((a:CutType, b:CutType) => a.number - b.number);
      } else {
        this.cuts = []
      }
    } catch (e) {
      console.log(e)
      notify_service.error('Ошибка запроса списка срезок')
      this.cuts = []
    }

  }


  getCut(e:any) {
    this.target_cut = e.data;
  }

  async onReorder(e: any) {
    if (e.toIndex === e.fromIndex) {
      return
    }
    const visibleRows = e.component.getVisibleRows();
    const toIndex = this.cuts.findIndex((cut: CutType) => cut.id === visibleRows[e.toIndex].data.id);
    const fromIndex = this.cuts.findIndex((cut: CutType) => cut.id === e.itemData.id);
    const newCuts = [ ...this.cuts ];

    newCuts.splice(fromIndex, 1);
    newCuts.splice(toIndex, 0, e.itemData);

    this.cuts = newCuts;
    for (let i=0;i<this.cuts.length; i++) {
      this.cuts[i].number = i + 1;
    }
    const savesCuts: CutType[] = [];
    for(let cut of this.cuts) {
      const cloneCut: any = _.cloneDeep(cut);
      let saveCut: CutType = new CutType();
      for (let key in saveCut) {
          //@ts-ignore
          saveCut[key] = cloneCut[key];
      }
      saveCut.created_by_id = cloneCut.created_by_id;
      saveCut.id = cloneCut.id;
      saveCut.modified_by_id = cloneCut.modified_by_id;
      saveCut.date_created = cloneCut.date_created;
      saveCut.date_modified = cloneCut.date_modified;
      savesCuts.push(saveCut);
    }
    await this.cut_service.put(savesCuts);
    await this.getCutsYear();
  }

  async rowUpdated(e: any) {
    const visibleRows = e.component.getVisibleRows();
    let fromIndex = -1;
    for(let i=0; i < visibleRows.length; i++) {
      if(visibleRows[i].data.id === e.data.id) {
        fromIndex = i;
      }
    }

    if(fromIndex != -1) {
      const newCuts = [...this.cuts];

      newCuts.splice(fromIndex, 1);
      newCuts.splice(e.data.number-1, 0, e.data);

      this.cuts = newCuts;
      for (let i=0;i<this.cuts.length; i++) {
        this.cuts[i].number = i + 1;
      }
      const savesCuts: CutType[] = [];
      for(let cut of this.cuts) {
        const cloneCut: any = _.cloneDeep(cut);
        let saveCut: CutType = new CutType();
        for (let key in saveCut) {
            //@ts-ignore
            saveCut[key] = cloneCut[key];
        }
        saveCut.created_by_id = cloneCut.created_by_id;
        saveCut.id = cloneCut.id;
        saveCut.modified_by_id = cloneCut.modified_by_id;
        saveCut.date_created = cloneCut.date_created;
        saveCut.date_modified = cloneCut.date_modified;
        savesCuts.push(saveCut);
      }
      await this.cut_service.put(savesCuts)
      await this.getCutsYear();
    }
  }

  async reorderAfterDelete(removeItemI: string | number) {
    let count = 1;
    const reorderCuts: CutWithAccept[] = [];
    for (let cut of this.cuts) {
      if (cut.id !== removeItemI) {
        cut.number = count;
        count += 1;
        reorderCuts.push(cut);
      }
    }
    return  reorderCuts;
  }

  onCreate() {
    this.target_cut = new CutWithAccept();
    this.cutPopup.visible = true;

  }

  onEdit() {
    if (!this.target_cut?.id) return;

    this.cutPopup.editMode = true;
    this.cutPopup.visible = true;
  }

  async onDelete() {
    if (!this.target_cut?.id) return;
    await confirm(`Удалить срезку "${this.target_cut.name}"?`, "Удаление срезки").then(
      async (answer: boolean) => {
        if (!answer) {
          return;
        }

        if (this.target_cut?.id) {
          const grid = getGridInstance(this.$refs.typeGrid);
          grid.beginCustomLoading()

          const reorderCuts = await this.reorderAfterDelete(this.target_cut.id);

          try {
            const response = await this.cut_service.deleteAndReorded(this.target_cut.id, reorderCuts, this.current_year);
            this.getCutsYear();
            grid.endCustomLoading();
          } catch (e) {
            grid.endCustomLoading();
          }
        }
      }
    );
  }

  onOpenLog() {

    this.cutHistoryPopup.visible = true;

  }

  empty(){
    //
  }

  checkLenght(e:any){
    if(e.value) {
      if(e.value <= this.length) {
        return true;
      } else {
        return false;
      }
    }
  }

  changeAllYear() {
    this.all_years = YearService.YearList;
  }

  onAdd() {
    this.yearPopup.visible = true;
  }

  async onDeleteYear() {
    if (!this.current_year) {
      notify_service.error('Не выбран год для удаления');
      return;
    }
    const yearObj = this.all_years.find(y => y.id === this.current_year);
    const yearName = yearObj ? yearObj.name : this.current_year;
    const status = await YearService.checkDelete(this.current_year);
    if (status === 'Exist_cuts') {
      notify_service.error('Удаление невозможно. Для выбранного года уже существуют срезки.');
      return;
    }
    // Подтверждение
    await confirm(`Вы уверены, что хотите удалить год ${yearName}? Отменить действие будет невозможно.`, 'Удаление года').then(async (answer) => {
      if (!answer) return;
      const ok = await YearService.deleteYear(this.current_year);
      if (ok) {
        notify_service.success('Год успешно удалён');
        // Обновить список годов и выбранный год
        this.all_years = YearService.YearList;
        if (this.all_years.length) {
          this.current_year = this.all_years[this.all_years.length - 1].id;
        } else {
          this.current_year = '';
        }
        await this.getCutsYear();
      } else {
        notify_service.error('Ошибка удаления года. Возможно, год уже был удалён или имеются связанные срезки.');
      }
    });
  }

  @Watch("current_year")
    changeYear() {
      if (this.isLoaded) {
        this.getCutsYear()
      }
    }

    @Watch("cut_service.acceptIsChanged")
    reloadData() {
      if (this.cut_service.acceptIsChanged) {
        this.getCutsYear();
        this.cut_service.acceptIsChanged = false;
      }
    }

}
